import Ajax from '@utils/ajax';

export function submitCategories(data) {
	return Ajax.post('/reports/eeo_category_mapping/save', data);
}
